import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const videoUrl = (id) => `${API}/projects/${id}/video`;
export const thumbnailUrl = (id) => `${API}/projects/${id}/thumbnail`;
